import BnovoIcon from '@/assets/img/pages/tariffs/channel-manager/bnovo.svg?component';
import ExelyIcon from '@/assets/img/pages/tariffs/channel-manager/exely.svg?component';
import KonturIcon from '@/assets/img/pages/tariffs/channel-manager/kontur.svg?component';
import TLIcon from '@/assets/img/pages/tariffs/channel-manager/travel_line.svg?component';
import Access from '@/assets/img/svg/access.svg?component';
import Add from '@/assets/img/svg/add.svg?component';
import AlertFull from '@/assets/img/svg/alert-full.svg?component';
import Alert from '@/assets/img/svg/alert.svg?component';
import ArrowDropdown from '@/assets/img/svg/arrow-dropdown.svg?component';
import ArrowLeft from '@/assets/img/svg/arrow-left.svg?component';
import ArrowRight from '@/assets/img/svg/arrow-right.svg?component';
import BackArrow from '@/assets/img/svg/back-arrow.svg?component';
import Ball from '@/assets/img/svg/ball.svg?component';
import Bell from '@/assets/img/svg/bell.svg?component';
import Block from '@/assets/img/svg/block.svg?component';
import BookingLock from '@/assets/img/svg/booking-lock.svg?component';
import BriefcaselLock from '@/assets/img/svg/briefcase-lock.svg?component';
import Briefcase from '@/assets/img/svg/briefcase.svg?component';
import Burger from '@/assets/img/svg/burger.svg?component';
import CalendarTick from '@/assets/img/svg/calendar-tick.svg?component';
import Calendar from '@/assets/img/svg/calendar.svg?component';
import CancelEdit from '@/assets/img/svg/cancel-edit.svg?component';
import CheckCircle from '@/assets/img/svg/check-circle.svg?component';
import CheckIcon from '@/assets/img/svg/check.svg?component';
import ChevronDown from '@/assets/img/svg/chevron-down.svg?component';
import ChevronUp from '@/assets/img/svg/chevron-up.svg?component';
import clipboardList from '@/assets/img/svg/clipboard-list.svg?component';
import Clock from '@/assets/img/svg/clock.svg?component';
import CloseCircle from '@/assets/img/svg/close-circle.svg?component';
import CloseDrawer from '@/assets/img/svg/close-drawer.svg?component';
import CloseSvg from '@/assets/img/svg/close.svg?component';
import CloudCrossed from '@/assets/img/svg/cloud-crossed.svg?component';
import Content from '@/assets/img/svg/content.svg?component';
import Copy from '@/assets/img/svg/copy.svg?component';
import Dashboard from '@/assets/img/svg/dashboard.svg?component';
import DocumentCheckBlock from '@/assets/img/svg/document-check-block.svg?component';
import DocumentCheck from '@/assets/img/svg/document-check.svg?component';
import DocumentText from '@/assets/img/svg/document-text.svg?component';
import Document from '@/assets/img/svg/document.svg?component';
import DocumentsLock from '@/assets/img/svg/documents-lock.svg?component';
import Documents from '@/assets/img/svg/documents.svg?component';
import Dots from '@/assets/img/svg/dots.svg?component';
import DoubleCheck from '@/assets/img/svg/double-check.svg?component';
import Download from '@/assets/img/svg/download.svg?component';
import EditPen from '@/assets/img/svg/edit-pen.svg?component';
import Exit from '@/assets/img/svg/exit.svg?component';
import Folder from '@/assets/img/svg/folder.svg?component';
import Gallery from '@/assets/img/svg/gallery.svg?component';
import Graph from '@/assets/img/svg/graph.svg?component';
import Grid from '@/assets/img/svg/grid.svg?component';
import HotelLock from '@/assets/img/svg/hotel-lock.svg?component';
import Hotel from '@/assets/img/svg/hotel.svg?component';
import Info from '@/assets/img/svg/info-circle.svg?component';
import Ironing from '@/assets/img/svg/ironing.svg?component';
import KeyBook from '@/assets/img/svg/key-book.svg?component';
import Kids from '@/assets/img/svg/kids.svg?component';
import Knowledge from '@/assets/img/svg/knowledge.svg?component';
import LeftChevron from '@/assets/img/svg/left-chevron.svg?component';
import LightBulb from '@/assets/img/svg/light-bulb.svg?component';
import Lock from '@/assets/img/svg/lock.svg?component';
import MapPin from '@/assets/img/svg/map-pin.svg?component';
import MessageSend from '@/assets/img/svg/message-send.svg?component';
import Nutrition from '@/assets/img/svg/nutrition.svg?component';
import ObjectContent from '@/assets/img/svg/object-content.svg?component';
import OpenDrawer from '@/assets/img/svg/open-drawer.svg?component';
import Options from '@/assets/img/svg/options.svg?component';
import Pdf from '@/assets/img/svg/pdf.svg?component';
import PresentionChart from '@/assets/img/svg/presention-chart.svg?component';
import Profile from '@/assets/img/svg/profile.svg?component';
import Promo from '@/assets/img/svg/promo.svg?component';
import Puzzle from '@/assets/img/svg/puzzle.svg?component';
import Question from '@/assets/img/svg/question.svg?component';
import Reflect from '@/assets/img/svg/reflect.svg?component';
import Refresh from '@/assets/img/svg/refresh.svg?component';
import Restaurant from '@/assets/img/svg/restaurant.svg?component';
import RightChevron from '@/assets/img/svg/right-chevron.svg?component';
import Room from '@/assets/img/svg/room.svg?component';
import RotateLeft from '@/assets/img/svg/rotate-left.svg?component';
import SandClock from '@/assets/img/svg/sand-clock.svg?component';
import Search from '@/assets/img/svg/search.svg?component';
import Settings from '@/assets/img/svg/settings.svg?component';
import Shop from '@/assets/img/svg/shop.svg?component';
import Sorting from '@/assets/img/svg/sorting.svg?component';
import StarMagic from '@/assets/img/svg/star-magic.svg?component';
import Support from '@/assets/img/svg/support.svg?component';
import Table from '@/assets/img/svg/table.svg?component';
import Tariff from '@/assets/img/svg/tariff.svg?component';
import Trash from '@/assets/img/svg/trash.svg?component';
import Tratment from '@/assets/img/svg/treatment.svg?component';
import UserMultiple from '@/assets/img/svg/user-multiple.svg?component';
import Users3 from '@/assets/img/svg/users-3.svg?component';
import UsersLock from '@/assets/img/svg/users-lock.svg?component';
import Wand from '@/assets/img/svg/wand.svg?component';
import WiFi from '@/assets/img/svg/wi-fi.svg?component';

export default {
  arrowRight: ArrowRight,
  closeSvg: CloseSvg,
  arrowLeft: ArrowLeft,
  editPen: EditPen,
  openDrawer: OpenDrawer,
  closeDrawer: CloseDrawer,
  calendarTick: CalendarTick,
  userMultiple: UserMultiple,
  options: Options,
  sandClock: SandClock,
  block: Block,
  check: CheckIcon,
  alert: Alert,
  alertFull: AlertFull,
  plus: Add,
  gallery: Gallery,
  dots: Dots,
  trash: Trash,
  table: Table,
  grid: Grid,
  calendar: Calendar,
  search: Search,
  messageSend: MessageSend,
  dashboard: Dashboard,
  hotel: Hotel,
  room: Room,
  ironing: Ironing,
  tariff: Tariff,
  keyBook: KeyBook,
  puzzle: Puzzle,
  graph: Graph,
  content: Content,
  documents: Documents,
  document: Document,
  knowledge: Knowledge,
  bell: Bell,
  folder: Folder,
  users3: Users3,
  briefcase: Briefcase,
  support: Support,
  profile: Profile,
  question: Question,
  exit: Exit,
  burger: Burger,
  chevronRight: RightChevron,
  chevronLeft: LeftChevron,
  access: Access,
  checkCircle: CheckCircle,
  arrowDropdown: ArrowDropdown,
  reflect: Reflect,
  rotateLeft: RotateLeft,
  clock: Clock,
  info: Info,
  settings: Settings,
  nutrition: Nutrition,
  promo: Promo,
  mapPin: MapPin,
  lightBulb: LightBulb,
  backArrow: BackArrow,
  lock: Lock,
  wand: Wand,
  contentsOR: ObjectContent,
  copy: Copy,
  download: Download,
  closeCircle: CloseCircle,
  refresh: Refresh,
  hotelLock: HotelLock,
  briefcaselLock: BriefcaselLock,
  documentsLock: DocumentsLock,
  usersLock: UsersLock,
  bookingLock: BookingLock,
  clipboardList: clipboardList,
  offline: CloudCrossed,
  TLIcon: TLIcon,
  ExelyIcon: ExelyIcon,
  BnovoIcon: BnovoIcon,
  KonturIcon: KonturIcon,
  documentText: DocumentText,
  chevronDown: ChevronDown,
  shop: Shop,
  ball: Ball,
  kids: Kids,
  restaurant: Restaurant,
  treatment: Tratment,
  wiFi: WiFi,
  chevronUp: ChevronUp,
  pdf: Pdf,
  cancelEdit: CancelEdit,
  starMagic: StarMagic,
  presentionChart: PresentionChart,
  documentCheck: DocumentCheck,
  documentCheckBlock: DocumentCheckBlock,
  doubleCheck: DoubleCheck,
  sorting: Sorting,
};
